// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__RCIVn","title":"Info_title__2B8q0","selects":"Info_selects__3FdIT","requiredAsterisk":"Info_requiredAsterisk__3Ond8"};